var map = {
	"./home": [
		"RiZL",
		5
	],
	"./home.vue": [
		"RiZL",
		5
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a8u2";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/layouts lazy ^\.\/.*$
// module id = a8u2
// module chunks = 7